import Header from '../components/header/header'
import Footer from '../components/footer/footer'
import Equipment from '../components/navigater'
import styles from './marathon.module.scss'
import bStyles from './boxing.module.scss'
import { Fragment, useEffect } from 'react'
import Play from '../home/images/btn_play@2x.png'
import { useState } from 'react'
import equip1 from './images/marathon-equip-1.png'

import equip2 from './images/marathon-equip-2.png'

import equip3 from './images/marathon-equip-3.png'
import equip4 from './images/marathon-equip-4.png'
import equip5 from './images/marathon-equip-5.png'

import equip6 from './images/marathon-equip-6.png'
import equip7 from './images/marathon-equip-7.png'

import equip8 from './images/marathon-equip-8.png'
import equip9 from './images/marathon-equip-9.png'
import equip10 from './images/marathon-equip-10.png'

import equip11 from './images/marathon-equip-11.png'
import equip12 from './images/marathon-equip-12.png'

import poster from './images/poster.png'



function CreateVideo({ list, setList }) {
  // const [list, setList] = useState([])
  const playVideo = (index, id) => {
    list[index].contro = true
    setList(list.map(item => item))
    document.getElementById('video' + id).play()
  }
  return (
    <div className={styles.videoBox}>
      {list.map((item, index) => (
        <div key={index}>
          {!item.contro && (
            <img
              className={styles.play}
              src={Play}
              alt='play'
              onClick={() => playVideo(index, item.id)}
            />
          )}
          {!item.contro && (
            <img className={styles.poster} src={item.poster} alt='poster' />
          )}
          <video
            id={'video' + item.id}
            controls
            role='img'
            src={item.src}
          ></video>
        </div>
      ))}
    </div>
  )
}
function Home() {
  const _path = [
    {
      title: 'Home',
      href: '/',
    },
    {
      title: 'AI Marathon Workstation',
      href: '',
    },
  ]

  const [videoList, setVideoList] = useState([])

  useEffect(() => {
    document.body.scrollTop = 0
    setVideoList([
      {
        poster: poster,
        contro: false,
        id: 'marathon',
        src: 'https://www.xempowerusa.com/videos/workstation.mp4',
      },
    ])
  }, [])

  const functionList = [
    { id: 1, title: 'Timing & Camera & GPS' },
    { id: 2, title: 'Running Bibs & band' },
    { id: 3, title: 'APP' },
    { id: 4, title: 'Timing & Camera & SOS & GPS' },
    { id: 5, title: 'Timing & Camera & GPS' },
    { id: 6, title: 'Data & Live Streaming & Workstation' },
  ]

  return (
    <Fragment>
      <Header />
      <Equipment title='Equipment Solutions' path={_path} />
      <main
        style={{
          fontSize: '20px',
          color: '#6D4C47',
        }}
      >
        <div
          style={{
            width: '100%',
            height: '550px',
            background: '#000',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <CreateVideo list={videoList} setList={setVideoList} />
        </div>
        <div
          className={styles.mainContainer}
          style={{ width: '1400px', margin: '0 auto' }}
        >
          <div className={styles.section}>
            <div className={styles.sectionTitle}>Application Scenarios</div>
            <div className={styles.sectionContent}>
              <div>
                <img src={equip1} alt='' width={1340} height={670} />
              </div>
              <div
                style={{ display: 'flex', flexWrap: 'wrap', padding: '0 40px' }}
              >
                {functionList.map(item => {
                  return (
                    <div
                      key={item.id}
                      style={{
                        width: item.id === 6 ? '50%' : '25%',
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '40px',
                      }}
                    >
                      <span
                        style={{
                          width: '26px',
                          height: '26px',
                          background: '#99746E',
                          borderRadius: '6px 0 6px 0',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '20px',
                          fontWeight: 700,
                          marginRight: '20px',
                        }}
                      >
                        {item.id}
                      </span>
                      <span style={{ fontSize: '20px', color: '#99746E' }}>
                        {item.title}
                      </span>
                    </div>
                  )
                })}
              </div>
              <div style={{ marginTop: '70px' }}>
                <p>
                  In terms of marathon events, with the aim of creating a safer,
                  more efficient and personalized event experience for runners,
                  we have independently developed an AI marathon workstation for
                  marathon sports and events. This system and its equipment are
                  both the first of their kind worldwide. It is compatible with
                  core functions, such as Course Timing, AI Monitoring, AI
                  Anti-cheating, AI Short Videos, AI Live Streaming, and AI
                  Scheduling.
                </p>
                <p style={{ marginTop: '20px' }}>
                  This system, based on artificial intelligence (AI) and
                  biometric technology, enables unattended operation of on-site
                  workstation equipment. The on-site videos and data will be
                  live-streamed throughout, serving every runner. It has been
                  successfully applied in some marathon events in 2024 and
                  marathon events in 2025.
                </p>
              </div>
            </div>
          </div>
          <div className={styles.section}>
            <div className={styles.sectionTitle}>Product Features</div>
            <div className={styles.sectionContent}>
              <div
                style={{
                  position: 'relative',
                  width: '1400px',
                  height: '666px',
                }}
              >
                <img
                  style={{ position: 'absolute' }}
                  src={equip2}
                  alt=''
                  width={1400}
                  height={666}
                />
                <div
                  className={styles.absoluteM}
                  style={{ position: 'absolute', left: '130px', top: '35%' }}
                >
                  <p
                    style={{
                      color: '#411108',
                      fontSize: '40px',
                      width: '240px',
                      textAlign: 'right',
                    }}
                  >
                    Event Management
                  </p>
                  <p style={{ textAlign: 'right' }}>Real-Time Monitoring</p>
                  <p style={{ textAlign: 'right' }}>Traffic Analysis</p>
                  <p style={{ textAlign: 'right' }}>Anti-Cheating</p>
                </div>
                <div
                  className={styles.absoluteM}
                  style={{ position: 'absolute', right: '40px', top: '40%' }}
                >
                  <p style={{ color: '#411108', fontSize: '40px' }}>
                    Event Services
                  </p>
                  <p>Personal Short Videos</p>
                  <p>Event Live Broadcasts</p>
                  <p>Runner Status Query (Catcher System)</p>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.section}>
            <div className={styles.sectionTitle}>
              Design & On-site Exhibition
            </div>
            <div className={styles.sectionContent}>
              <div
                style={{
                  width: '400px',
                  height: '68px',
                  lineHeight: '68px',
                  fontSize: '32px',
                  paddingLeft: '24px',
                  marginBottom: '40px',
                  backgroundImage: `linear-gradient(90deg, #ffe2b999 0%, #ffe2b900 100%)`,
                }}
              >
                Product
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <img src={equip3} alt='' height={400} width={296} />
                <img src={equip5} alt='' height={400} width={598} />
                <img src={equip4} alt='' height={400} width={482} />
              </div>
              <div
                style={{
                  width: '400px',
                  height: '68px',
                  lineHeight: '68px',
                  fontSize: '32px',
                  paddingLeft: '24px',
                  marginTop: '90px',
                  marginBottom: '40px',
                  backgroundImage: `linear-gradient(90deg, #ffe2b999 0%, #ffe2b900 100%)`,
                }}
              >
                On-site Exhibition
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <img src={equip6} alt='' height={400} width={694} />
                <img src={equip7} alt='' height={400} width={694} />
                
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '14px' }}>
                <img src={equip8} alt='' height={400} width={458} />
                <img src={equip9} alt='' height={400} width={458} />
                <img src={equip10} alt='' height={400} width={458} />
              </div>
            </div>
          </div>

          
        </div>
        <div style={{ position: 'relative', marginTop: '144px', height: '1338px' }}>
          
          <img src={equip12} alt="" height={1338} style={{ width: '100%', position: 'absolute' }} />
          <img src={equip11} alt="" style={{ position: 'absolute', top: '250px', left: '50%', transform: 'translateX(-50%)' }} width={1400} height={1008} />
          <p style={{position: 'absolute', width: '100%', textAlign: 'center', top: '80px', color: '#fff', fontSize: '60px'}}>What Can Xempower Do?</p>
        </div>
      </main>
      <Footer />
    </Fragment>
  )
}

export default Home
